var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-form-input", {
    class: _vm.inputClass,
    style: _vm.inputStyle,
    attrs: {
      type: _vm.type,
      readonly: _vm.disabled,
      oninput: _vm.oninput,
      maxLength: _vm.maxLength,
      min: _vm.minLength,
      placeholder: _vm.placeholder,
      autocomplete: _vm.autocomplete,
      "no-wheel": _vm.noWheel
    },
    on: {
      input: _vm.input,
      keypress: function($event) {
        return _vm.keypress($event)
      },
      keyup: function($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
        ) {
          return null
        }
        return _vm.keyupEnter($event)
      },
      focus: _vm.onFocus,
      keydown: function($event) {
        return _vm.keydown($event)
      }
    },
    model: {
      value: _vm.selectedValue,
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-996cddd2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-996cddd2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NextInput.vue
// module id = null
// module chunks = 